export default "__VITE_ASSET__DVoHy8LV__"